import { useCallback } from "react";
import { useRecoilValue } from "recoil";
import { CrossoutsAtom, GoalHintsAtom } from "../utils/context";
export function useHints() {
    var goalHints = useRecoilValue(GoalHintsAtom);
    var crossout = useRecoilValue(CrossoutsAtom);
    var getProgress = useCallback(function () {
        var allLines = Array.from(crossout.values());
        var allHints = allLines.flatMap(function (l) { return l.line; });
        var crossouts = allHints.filter(function (c) { return c.crossout; });
        var overflowLines = allLines.filter(function (l) { return l.overflow; });
        var invalidCrossout = overflowLines.flatMap(function (ol) { return ol.line; });
        return Math.floor(((crossouts.length - invalidCrossout.length) / allHints.length) * 100);
    }, [crossout]);
    return {
        goalHints: goalHints,
        getProgress: getProgress
    };
}
